import type { Maybe } from '@adornis/base/utilTypes.js';
import type { Adresse } from '@martinus/address/entities/Adresse.js';
import { JobTicketWrapper } from '../db/job-ticket-wrapper.js';
import type { MitarbeiterDaten } from '../users/employees/entities/mitarbeiter-daten.js';
import type { StammDaten } from '../users/profile/entities/StammDaten.js';

/**
 * The person data a job ticket is built from. Structural on purpose: callers hand in either a full
 * `Person` or one narrowed to a selection set, and a narrowed entity keeps no `Person` methods.
 */
export interface JobTicketSource {
  profilDaten?: Maybe<{ stammdaten?: Maybe<Partial<StammDaten>>; adresse?: Maybe<Partial<Adresse>> }>;
  mitarbeiterDaten?: Maybe<Partial<MitarbeiterDaten>>;
}

/** Flattens the job ticket relevant person data into the wrapper the form and the CSV export use. */
export const jobTicketWrapperFromPerson = (person: JobTicketSource) => {
  const stammdaten = person.profilDaten?.stammdaten;
  const adresse = person.profilDaten?.adresse;
  const mitarbeiterDaten = person.mitarbeiterDaten;

  return new JobTicketWrapper({
    titel: stammdaten?.titel,
    vorname: stammdaten?.vorname,
    nachname: stammdaten?.nachname,
    namenszusatz: stammdaten?.namenszusatz,
    vorsatzWort: stammdaten?.vorsatzWort,
    geburtsDatum: stammdaten?.geburtsDatum,
    geschlecht: stammdaten?.geschlecht ?? undefined,
    streetAndNumber: adresse?.streetAndNumber,
    zip: adresse?.zip,
    city: adresse?.city,
    country: adresse?.country,
    jobTicketKenntnis: mitarbeiterDaten?.jobTicketKenntnis,
    jobTicketBestaetigt: mitarbeiterDaten?.jobTicketBestaetigt,
    jobTicketDatenweitergabe: mitarbeiterDaten?.jobTicketDatenweitergabe,
    deutschlandTicketBestellt: mitarbeiterDaten?.deutschlandTicketBestellt,
    jobTicketExportiertAm: mitarbeiterDaten?.jobTicketExportiertAm,
    jobTicketBestellDatum: mitarbeiterDaten?.jobTicketBestellDatum,
    jobTicketKuendigungsDatum: mitarbeiterDaten?.jobTicketKuendigungsDatum,
  });
};
